import request from "../../utils/api";

export const getProperties = params => {
  return request("v1/sellers/properties", {
    params
  });
};

export const getBuildings = params => {
  const { propertyCode, brand } = params;
  const url = `v1/sellers/${brand}/properties/${propertyCode}/buildings`;

  return request(url, {
    params
  });
};

export const getUnits = params => {
  const { brand, propertyCode, buildingCode } = params;
  const url = `v1/sellers/${brand}/properties/${propertyCode}/buildings/${buildingCode}/units`;

  return request(url, {
    params
  });
};
